import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/editor/translation.history.query.gql"
import type {
  TranslationHistoryQuery,
  TranslationHistoryQueryVariables,
} from "@/v2-backoffice-client/translation/editor/__types__/translation.history.query"

type Options = QueryHookOptions<
  TranslationHistoryQuery,
  TranslationHistoryQueryVariables
>

export function useTranslationHistoryQuery(options?: Options) {
  return useQuery<TranslationHistoryQuery, TranslationHistoryQueryVariables>(
    query,
    options,
  )
}
